module.exports = __webpack_public_path__ + "assets/img/2.bf495386.webp";